import Constants from '../../../../util/Constants'

export default class SpatialDelegate {
  constructor( { items, imageRatios } ) {
    this.setItems( items || [] )
  }

  setItems( items ) {
    if ( this.items !== items ) {
      this.items = items || []

      // Sort them by size so smallest are selected/rollover first
      this.sortedItems = this.items
        .filter( i => i?.data?.data?.data?.detection?.bbox != null )
        .map( ( i ) => {
          return {
            data : i,
            size : i.data.data.data.detection.bbox.width * i.data.data.data.detection.bbox.height
          }
        } )

      this.sortedItems.sort( ( a, b ) => {
        return a.size - b.size
      } )
      this.sortedItems = this.sortedItems.map( i => i.data )
    }
  }

  getItemsUnder( pt, opts, event ) {
    // for our example, we will just look at the rect object. This could be 
    // done with an attribute, like what we do with geo points
    const r = []

    for ( let n = 0; n < this.sortedItems.length; n++ ) {
      const item = this.sortedItems[n]
      if ( item?.data?.data?.data?.detection?.bbox ) {
        const itemBBox = item.data.data.data.detection.bbox
        const itemDimensions = item.data.data.data.detection.dimensions
        const imageRatios = {
          ...Constants.SHELF_MONITORING_IMAGE_SIZE.segment,
          original : itemDimensions ?? Constants.SHELF_MONITORING_IMAGE_SIZE.segment.original
        }
        const widthRatio = imageRatios.thumbnail.width / imageRatios.original.width
        const heightRatio = imageRatios.thumbnail.height / imageRatios.original.height

        const height = itemBBox.height * heightRatio

        const bbox = {
          left : itemBBox.left * widthRatio,
          width : itemBBox.width * widthRatio,
          height,
          top : imageRatios.thumbnail.height - ( itemBBox.top * heightRatio ) - height,
        }

        if ( this.isPointInRect( pt, bbox ) ) {
          r.push( item )
        }
      }
    }
    return r
  } 

  getTopItemUnder( pt, opts, event ) {
    const items = this.getItemsUnder( pt, opts, event )
    return items[0]
  }

  isPointInRect( point, rect ) {
    return (
      point.x >= rect.left &&
      point.x <= rect.left + rect.width &&
      point.y >= rect.top &&
      point.y <= rect.top + rect.height
    )
  }
}
